import { render, staticRenderFns } from "./SetPasswordModal.vue?vue&type=template&id=b2dbd1d0"
import script from "./SetPasswordModal.vue?vue&type=script&lang=js"
export * from "./SetPasswordModal.vue?vue&type=script&lang=js"
import style0 from "./SetPasswordModal.vue?vue&type=style&index=0&id=b2dbd1d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports